/* ================== THE CLAIM CTA ==================
   The shop button does not sit still. It wears one of the five OG crew
   colours, changes every 1.7s, and whatever colour it is wearing is the
   colour it takes you to — the vessel bay with that hue already selected,
   or that colour's product page once the doors are open.

   Reduced motion pins it to green and it behaves like a plain button.
   ==================================================================== */
(function () {
  if (window.STATION_CLAIM) return;

  /* the OG five, in the site's own canonical order and inks */
  var CREW = [
    { id: 'green',  name: 'GREEN',  ink: '#00CE7E', deep: '#00A967', on: '#04120A' },
    { id: 'pink',   name: 'PINK',   ink: '#EA41AA', deep: '#C22C8B', on: '#20040F' },
    { id: 'red',    name: 'RED',    ink: '#FC4539', deep: '#D22C22', on: '#1E0503' },
    { id: 'yellow', name: 'YELLOW', ink: '#F8E44B', deep: '#D8C023', on: '#1A1602' },
    { id: 'blue',   name: 'BLUE',   ink: '#389EE1', deep: '#1F7BBA', on: '#03121E' }
  ];
  var HOLD = 1700;
  var i = 0;

  /* a colour that has sold out never takes a turn on the button */
  function wearable() {
    var live = (window.STATION_LIVE_CREW || null);
    if (!live || !live.length) return CREW;
    var out = CREW.filter(function (c) { return live.indexOf(c.id) !== -1; });
    return out.length ? out : CREW;
  }

  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Where a colour goes. Pre-drop the products are drafts, so the honest
     destination is the vessel bay with the hue pre-selected. Once
     COMING_SOON is off, go straight to that colour's product page. */
  function href(c) {
    var live = (typeof window.STATION_COMING_SOON === 'boolean') ? !window.STATION_COMING_SOON : false;
    /* the real Shopify handle is <colour>-alien-618 — the same one the cart
       resolves against. Anything else lands on a 404 on the biggest day. */
    if (live) {
      var s = (window.STATION_STOCK || {})[c.id];
      if (s && s.url) return s.url;
      return '/products/' + c.id + '-alien-618';
    }
    return (location.pathname.indexOf('/pages/') === 0 ? '/' : '') + '#/bottles?color=' + c.id;
  }

  /* the five photos: station.js carries them as OG_IMG on the main decks; the markup carries the asset URLs everywhere */
  function bottleFor(id, img) {
    try { if (typeof OG_IMG !== 'undefined' && OG_IMG && OG_IMG[id]) return OG_IMG[id]; } catch (e) {}
    var map = img.getAttribute('data-bottles') || '';
    var parts = map.split('|');
    for (var p = 0; p < parts.length; p++) {
      var at = parts[p].indexOf('=');
      if (at > 0 && parts[p].slice(0, at) === id) return parts[p].slice(at + 1);
    }
    return '';
  }

  function targets() {
    return [].slice.call(document.querySelectorAll('.claim-btn, .menu-cta, .sb-buy'));
  }

  function wear(c) {
    targets().forEach(function (el) {
      el.setAttribute('href', href(c));
      el.dataset.claimColor = c.id;

      if (el.classList.contains('menu-cta')) {
        el.style.background = 'linear-gradient(180deg,' + c.ink + ',' + c.deep + ')';
        el.style.borderColor = c.ink;
        el.style.color = c.on;
        var k = el.querySelector('.mc-k'), t = el.querySelector('.mc-t');
        if (k) k.textContent = 'THE VESSELS · 100 PER COLOUR';
        if (t) t.textContent = 'CLAIM ' + c.name;
        /* V100: the vessel in the nose cone changes with the colour it is wearing */
        var img = el.querySelector('.mc-bottle');
        if (img) {
          var src = bottleFor(c.id, img);
          if (src && img.getAttribute('data-on') !== c.id) {
            img.setAttribute('data-on', c.id);
            img.classList.add('swap');
            setTimeout(function () { img.src = src; img.classList.remove('swap'); }, 150);
          }
        }
      } else {
        el.style.background = c.ink;
        el.style.borderColor = c.ink;
        el.style.color = c.on;
        el.innerHTML = 'CLAIM<span class="btn-words"> ' + c.name + '</span> <b>$33</b>';
      }
    });
  }

  /* clicking claims the colour it is wearing: pre-select it in the bay */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('.claim-btn, .menu-cta, .sb-buy') : null;
    if (!el) return;
    var id = el.dataset.claimColor;
    if (!id) { id = window.STATION_SHOWN || 'green'; }   /* an undressed buy control still claims the bottle on show */
    try { sessionStorage.setItem('station.claim.color', id); } catch (err) {}
    /* V179 · THE ONE ADD LAW: the claim adds the colour it is wearing, same as every other buy control */
    if (window.STATION_ADD) { e.preventDefault(); e.stopPropagation(); window.STATION_ADD('v-' + id, e.clientX, e.clientY); return; }
    /* no hold on this page: the home deck adds it on arrival */
    if (!document.getElementById('hold')) { e.preventDefault(); location.href = '/?add=v-' + id; return; }
    var chip = document.querySelector('[data-color="' + id + '"], [data-hue="' + id + '"], .chip[data-c="' + id + '"]');
    if (chip) { chip.click(); }
  }, true);


  /* ---- the tail of the ship: engine bell + fins, added once ---------- */
  function buildTail() {
    var panel = document.getElementById('menuPanel');
    if (!panel || panel.querySelector('.menu-engine')) return;
    var eng = document.createElement('div');
    eng.className = 'menu-engine';
    eng.innerHTML = '<b>DECK 00 · THE ENGINE</b>EVERY DECK ABOVE RUNS ON THIS ONE';
    panel.appendChild(eng);
  }


  /* ---- the deck colours: lift each item's hue onto the row itself so the
         icon, the chip and the glow can all share it ---------------------- */
  function paintDeckHues() {
    [].forEach.call(document.querySelectorAll('.menu-item'), function (row) {
      if (row.dataset.hued) return;
      var chip = row.querySelector('.mcolor');
      if (!chip) return;
      var hue = (chip.getAttribute('style') || '').match(/--mc:\s*(#[0-9a-fA-F]{3,8})/);
      if (!hue) return;
      row.style.setProperty('--mc', hue[1]);
      row.dataset.hued = '1';
    });
  }

  function start() {
    paintDeckHues();
    buildTail();
    if (!targets().length) return setTimeout(start, 300);
    wear(wearable()[0]);
    setTimeout(paintDeckHues, 400);
    if (reduced) return;
    var heroEl = document.getElementById('arrivals'), heroOn = false;
    if (heroEl && 'IntersectionObserver' in window) { try { new IntersectionObserver(function (es) { es.forEach(function (en) { heroOn = en.isIntersecting; }); }, { threshold: 0.35 }).observe(heroEl); } catch (e) {} }
    function shownCrew() { var k = window.STATION_SHOWN; if (!k) return null; for (var j = 0; j < CREW.length; j++) { if (CREW[j].id === k) return CREW[j]; } return null; }
    function followBottle() { var deck = document.documentElement.getAttribute('data-hero') || 'vessel'; if (!heroOn || deck !== 'vessel') return false; var c = shownCrew(); if (!c) return false; wear(c); return true; }
    addEventListener('station:vessel', function () { followBottle(); });
    setInterval(function () { if (followBottle()) return; var w = wearable(); i = (i + 1) % w.length; wear(w[i]); }, HOLD);
  }

  window.STATION_CLAIM = { crew: CREW, wear: wear, current: function () { var w = wearable(); return w[i % w.length]; } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
